/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useRef, useState } from "react";
import ic_agent_circle from "../../assets/images/pictures/icon/ic_agent_circle.svg";
import agent_header from "../../assets/images/pictures/vneid-des.png";
import ic_save_time from "../../assets/images/pictures/icon/Agent/ic_save_time.svg";
import ic_thunder from "../../assets/images/pictures/icon/Agent/ic_boost.svg";
import ic_save from "../../assets/images/pictures/icon/Agent/ic_save.svg";
import ic_thunder_big_circle from "../../assets/images/pictures/icon/ic_thunder_big_circle.svg";
import ic_connect from "../../assets/images/pictures/icon/Agent/ic_connect.svg";
import ic_enterprise from "../../assets/images/pictures/icon/Agent/ic_enterprise.svg";
import ic_goverment from "../../assets/images/pictures/icon/Agent/ic_goverment.svg";
import ic_commerce from "../../assets/images/pictures/icon/Agent/ic_commerce.svg";

import ic_security from "../../assets/images/pictures/icon/ic_security.svg";
import ic_inte from "../../assets/images/pictures/icon/Agent/ic_inte.svg";
import ic_handshake from "../../assets/images/pictures/icon/Agent/handshake.svg";
import ic_app from "../../assets/images/pictures/icon/Agent/application.svg";
import ic_friend from "../../assets/images/pictures/icon/Agent/friendly.svg";
import ic_management from "../../assets/images/pictures/icon/Agent/management.svg";
import ic_download_white from "../../assets/images/pictures/icon/ic_download-white.svg";
import gopaperless_service from "../../assets/images/pictures/solutions-footer.png";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import routeVariants from "../../assets/animates/routeVariants";
import Modal from "../global/Modal";
import cd from "../../assets/images/logos/e/cdlogo.png";
import gf from "../../assets/images/logos/e/gf-logo.png";
import moki from "../../assets/images/logos/e/moki.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AgentApiContent = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (modalOpen === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalOpen]);

  const modalRef = useRef(null);

  const handleOverlayClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setModalOpen(false);
    }
  };

  document.onkeydown = function (evt) {
    if (evt.code === "Escape") {
      setModalOpen(false);
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    if (props.following === true) {
      document.getElementById("agent-api").classList.add("active", "in");
    } else {
      document.getElementById("agent-api").classList.remove("active", "in");
    }
  }, [props.following]);

  return (
    <>
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        className="tab-pane fade"
        id="agent-api"
      >
        <div className="container pt-50 pb-50">
          <div className="row api-solutions">
            <div className="col-sm-6 pl-md-0 pt-50">
              <img
                width="64"
                height="64"
                src={ic_agent_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="heading font-weight-bold">
                {t(
                  "agent.header1"
                )}
              </h2>
              <div className="subheading">
                <p>
                  {t(
                    "agent.title1"
                  )}
                </p>
              </div>
              {/* <ul className="list-inline">
                <li>
                  <img className="client-s-none-width img-bw" src={cd} alt="" />
                </li>
                <li>
                  <img className="client-s-none-width img-bw" src={gf} alt="" />
                </li>
                <li>
                  <img
                    className="client-s-none-width img-bw"
                    src={moki}
                    alt=""
                  />
                </li>
              </ul> */}
            </div>
            <div className="col-sm-6 pr-md-0 ">
              <img
                src={agent_header}
                style={{marginTop:"130px"}}
                className="img-responsive"
                alt=""
                decoding="async"
                loading="lazy"
                width="400"
              />
            </div>
          </div>
        </div>

        <div className="bg-color py-100">
          <div className="container api-solutions ">
            <div className="row">
              <div className="col-sm-12 px-md-0">
                <div className="rectangle"></div>
                <h2 className="font-weight-bold">
                  {t(
                    "agent.why"
                  )}
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 mb-30">
                <img
                  width="40"
                  height="40"
                  src={ic_save_time}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />{" "}
                <h3>
                  {t(
                    "agent.why1"
                  )}
                </h3>
                <p>
                  {t(
                    "agent.why1_note"
                  )}
                </p>
              </div>
              <div className="col-sm-4 mb-30">
                <img
                  width="40"
                  height="40"
                  src={ic_thunder}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "agent.why2"
                  )}
                </h3>
                <p>
                  {t(
                    "agent.why2_note"
                  )}
                </p>
              </div>
              <div className="col-sm-4 mb-30 ">
                <img
                  width="40"
                  height="40"
                  src={ic_save}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "agent.why3"
                  )}
                </h3>
                <p>
                  {t(
                    "agent.why3_note"
                  )}
                </p>
              </div>
                <div className="col-sm-4 mb-30 ">
                <img
                  width="40"
                  height="40"
                  src={ic_connect}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "agent.why4"
                  )}
                </h3>
                <p>
                  {t(
                    "agent.why4_note"
                  )}
                </p>
              </div>
                <div className="col-sm-4 mb-30">
                <img
                  width="40"
                  height="40"
                  src={ic_enterprise}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "agent.why5"
                  )}
                </h3>
                <p>
                  {t(
                    "agent.why5_note"
                  )}
                </p>
              </div>
                <div className="col-sm-4 mb-30">
                <img
                  width="40"
                  height="40"
                  src={ic_goverment}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h3>
                  {t(
                    "agent.why6"
                  )}
                </h3>
                <p>
                  {t(
                    "agent.why6_note"
                  )}
                </p>
              </div>
            </div>
            <div className="row custom-center-row ">
              <div className="col-sm-4 mb-30 custom-center-item">
                <img
                  width="40"
                  height="40"
                  src={ic_commerce}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />{" "}
                <h3>
                  {t(
                    "agent.why7"
                  )}
                </h3>
                <p>
                  {t(
                    "agent.why7_note"
                  )}
                </p>
              </div>
           
              
              
            </div>
          </div>
        </div>

        <div className="container mt-100 api-solutions api-solutions--features">
          <div className="row">
            <div className="text-center col-xs-12">
              <img
                width="64"
                height="64"
                src={ic_thunder_big_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="font-weight-bold">
                {t(
                  "agent.feature"
                )}
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_inte}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "agent.feature1"
                      )}
                    </h4>
                    <p>
                      {t(
                        "agent.feature1_note"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_handshake}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                     <h4>
                      {t(
                        "agent.feature2"
                      )}
                    </h4>
                    <p>
                      {t(
                        "agent.feature2_note"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_app}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                     <h4>
                      {t(
                        "agent.feature3"
                      )}
                    </h4>
                    <p>
                      {t(
                        "agent.feature3_note"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_management}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                     <h4>
                      {t(
                        "agent.feature4"
                      )}
                    </h4>
                    <p>
                      {t(
                        "agent.feature4_note"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_security}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                     <h4>
                      {t(
                        "agent.feature5"
                      )}
                    </h4>
                    <p>
                      {t(
                        "agent.feature5_note"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="media-list">
                <div className="media text-center">
                  <div className="media-body">
                    <img
                      width="24"
                      height="24"
                      src={ic_friend}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    <h4>
                      {t(
                        "agent.feature6"
                      )}
                    </h4>
                    <p>
                      {t(
                        "agent.feature6_note"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="api-solutions bg-color--img-overlap mt-50 bg-color">
          <div className="container identification-footer">
            <div className="row">
              <div className="col-sm-6 pl-md-0">
                <h2 className="heading font-weight-bold">
                  {t(
                    "agent.gopaperless"
                  )}
                </h2>
                <div className="subheading">
                  <p>
                    {t(
                      "agent.gopaperless_note"
                    )}
                  </p>
                </div>
                

                <a
                  href="javascript:;"
                  onClick={() => setModalOpen(true)}
                  className="btn-secondary"
                >
                  {t(
                    "e-sealing-api-page.e-sealing-api-page-content.content-4.button-contact-us"
                  )}
                </a>
              </div>
              <div className="col-sm-6 pl-md-0">
                <img
                  src={gopaperless_service}
                  width="400px"
                  className="bg-color--img-overlap__img img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      {modalOpen && (
        <Modal
          setOpenModal={setModalOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-found-solution-fit")}
          description={t("modal.description-get-started")}
          type="Solutions - E Sealing API - e-Sealing in your e-service"
        />
      )}
      <ToastContainer />
    </>
  );
};

export default AgentApiContent;
